import React, { useEffect } from "react";
import VWLoading from "../../components/vwLoading/vwLoading";
import Message from "../../CommonData/Data/Message";
import moment from "moment";
import { connect } from "react-redux";
import { getDeviceCycle } from "../../store/device/actions";

const DeviceLifeCycle = (props) => {
    const { selectedDeviceID, deviceLifeCycle, errorMessage, isDeviceLifeCyclePending } = props;
    useEffect(() => {
        if (selectedDeviceID) {
            props.getDeviceCycle(selectedDeviceID);
        }
    }, [selectedDeviceID])
    return (
        <>
            {errorMessage && (
                <Message
                    type="danger"
                    defaultMessage={errorMessage}
                    baseClassName="alert"
                />
            )}
            {
                isDeviceLifeCyclePending ? <VWLoading height={40} width={40} /> : deviceLifeCycle?.assignedUsers &&
                    deviceLifeCycle?.assignedUsers.length ? (
                    <div className="list-group">
                        {deviceLifeCycle?.assignedUsers.map((data, index) => (
                            <div className="list-group-item" key={data.id}>
                                <div className="media">
                                    <div className="align-self-start mr-2">
                                        <span className="fa-stack">
                                            <em className="fa fa-circle fa-stack-2x text-info"></em>
                                            <em className="far fa-clock fa-stack-1x fa-inverse text-white"></em>
                                        </span>
                                    </div>
                                    <div className="media-body text-truncate">
                                        <p className="mb-1 mt-1">
                                            {data.type.toLowerCase() === 'return' ? 'Returned to ' : data.type.toLowerCase() === 'transfer' ? 'Transferred to ' : 'Assigned to '}<b>{data.toDisplayName}</b>
                                        </p>
                                        <p className="m-0">
                                            <small>
                                                From{" "}
                                                <em>
                                                    <b>{data.fromDisplayName || "NA"}</b>
                                                </em>
                                            </small>
                                        </p>
                                    </div>
                                    <div className="ml-auto">
                                        <small className="text-muted ml-2">
                                            {data.userAssignedDate ? moment(data.userAssignedDate).fromNow() : "NA"}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-danger d-flex justify-content-center align-items-center flex-column" style={{ minHeight: "100px" }}>
                        <div>
                            <em className="fas fa-database text-danger fs-3"></em>
                        </div>
                        <div className="fs-5">
                            No Records Found
                        </div>
                    </div>
                )
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    selectedDeviceID: state.device.selectedDeviceID,
    isDeviceLifeCyclePending: state.device.isDeviceLifeCyclePending,
    deviceLifeCycle: state.device.deviceLifeCycle,
    errorMessage: state.device.deviceLifeCycleErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    getDeviceCycle: (selectedDeviceID) => dispatch(getDeviceCycle(selectedDeviceID)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceLifeCycle);